export default __webpack_public_path__ + "static/media/CS_153.04b9cb79.png";